/* ============================================================
   iwant Brand Custom JavaScript for Shopify Impact Theme
   IWKJ600-B Product Page
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── 1. Scroll Fade-in Animation (IntersectionObserver) ─── */
  const fadeElements = document.querySelectorAll('.iwant-fade-in');

  if ('IntersectionObserver' in window) {
    const fadeObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    fadeElements.forEach((el) => fadeObserver.observe(el));
  } else {
    // Fallback: show all immediately
    fadeElements.forEach((el) => el.classList.add('is-visible'));
  }

  /* ─── 2. Stats Counter Animation ─── */
  const counters = document.querySelectorAll('.iwant-stats-counter__number');

  if (counters.length > 0 && 'IntersectionObserver' in window) {
    const counterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    counters.forEach((counter) => counterObserver.observe(counter));
  }

  function animateCounter(element) {
    const target = parseFloat(element.dataset.target);
    const decimals = parseInt(element.dataset.decimals || '0', 10);
    const duration = 2000;
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;

      element.textContent = current.toFixed(decimals);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.textContent = target.toFixed(decimals);
      }
    }

    requestAnimationFrame(step);
  }

  /* ─── 3. Specs Table Toggle ─── */
  const specsToggle = document.querySelector('.iwant-specs__toggle');
  const specsTable = document.querySelector('.iwant-specs__table-wrapper');
  const specsIcon = document.querySelector('.iwant-specs__toggle-icon');

  if (specsToggle && specsTable) {
    specsToggle.addEventListener('click', function () {
      const isOpen = specsTable.classList.contains('is-open');

      if (isOpen) {
        specsTable.style.maxHeight = specsTable.scrollHeight + 'px';
        requestAnimationFrame(() => {
          specsTable.style.maxHeight = '0';
        });
        specsTable.classList.remove('is-open');
        specsToggle.querySelector('.iwant-specs__toggle-text').textContent = '詳細スペックを見る';
      } else {
        specsTable.style.maxHeight = specsTable.scrollHeight + 'px';
        specsTable.classList.add('is-open');
        specsToggle.querySelector('.iwant-specs__toggle-text').textContent = '詳細スペックを閉じる';
        // After transition, remove max-height to allow dynamic content
        specsTable.addEventListener('transitionend', function handler() {
          if (specsTable.classList.contains('is-open')) {
            specsTable.style.maxHeight = 'none';
          }
          specsTable.removeEventListener('transitionend', handler);
        });
      }

      if (specsIcon) {
        specsIcon.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
      }
    });
  }

  /* ─── 4. Sticky Header Scroll Effect ─── */
  const header = document.querySelector('.header');

  if (header) {
    let lastScroll = 0;

    window.addEventListener('scroll', function () {
      const currentScroll = window.scrollY;

      if (currentScroll > 80) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ─── 5. Mobile Sticky Purchase Bar ─── */
  const stickyBar = document.querySelector('.iwant-sticky-bar');

  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 600) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }, { passive: true });
  }

  /* ─── 6. FAQ Accordion Enhancement ─── */
  const faqItems = document.querySelectorAll('.iwant-faq__item');

  faqItems.forEach(function (item) {
    const toggle = item.querySelector('.iwant-faq__question');
    const answer = item.querySelector('.iwant-faq__answer');
    const icon = item.querySelector('.iwant-faq__icon');

    if (toggle && answer) {
      toggle.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        // Close all other items
        faqItems.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) {
            other.classList.remove('is-open');
            const otherAnswer = other.querySelector('.iwant-faq__answer');
            const otherIcon = other.querySelector('.iwant-faq__icon');
            if (otherAnswer) otherAnswer.style.maxHeight = '0';
            if (otherIcon) otherIcon.style.transform = 'rotate(0deg)';
          }
        });

        if (isOpen) {
          item.classList.remove('is-open');
          answer.style.maxHeight = '0';
          if (icon) icon.style.transform = 'rotate(0deg)';
        } else {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          if (icon) icon.style.transform = 'rotate(180deg)';
        }
      });
    }
  });

});
